// extracted by mini-css-extract-plugin
export default {"toggle-button":"MenuToggle_toggle-button__pLii1"};